import { render, staticRenderFns } from "./OrderFoodPickup.vue?vue&type=template&id=0a3076a0&scoped=true"
import script from "./OrderFoodPickup.vue?vue&type=script&lang=js"
export * from "./OrderFoodPickup.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodPickup.vue?vue&type=style&index=0&id=0a3076a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3076a0",
  null
  
)

export default component.exports